export function chunkArray<T>(arr: Array<T>, chunkSize = 10): Array<Array<T>> {
  return Array(Math.ceil(arr.length / chunkSize))
    .fill(null)
    .map((_, i) => arr.slice(i * chunkSize, i * chunkSize + chunkSize));
}
